// extracted by mini-css-extract-plugin
export var container = "sauna-quiz-results-module--container--b6d98";
export var content = "sauna-quiz-results-module--content--9d7b6";
export var contentWrapper = "sauna-quiz-results-module--contentWrapper--23173";
export var cta = "sauna-quiz-results-module--cta--1af5e";
export var imageLabel = "sauna-quiz-results-module--imageLabel--3bc3c";
export var largeLabel = "sauna-quiz-results-module--largeLabel--1f607";
export var next = "sauna-quiz-results-module--next--45cc5";
export var prev = "sauna-quiz-results-module--prev--03d83";
export var quiz = "sauna-quiz-results-module--quiz--c81d4";
export var result = "sauna-quiz-results-module--result--ffde9";
export var resultContent = "sauna-quiz-results-module--resultContent--88c07";
export var resultImage = "sauna-quiz-results-module--resultImage--37f28";
export var results = "sauna-quiz-results-module--results--890d2";
export var resultsWrapper = "sauna-quiz-results-module--resultsWrapper--cc6f2";
export var roomSelection = "sauna-quiz-results-module--roomSelection--3738e";
export var section = "sauna-quiz-results-module--section--f0157";
export var sectiona = "sauna-quiz-results-module--sectiona--6c9b8";
export var selection = "sauna-quiz-results-module--selection--f1d7e";
export var selections = "sauna-quiz-results-module--selections--ea7d6";
export var smallLabel = "sauna-quiz-results-module--smallLabel--dfa43";